import React from 'react';
import * as Icons from '@tabler/icons-react';

const SportIcon = ({ iconName, size = 32, color, className = '' }) => {
  const IconComponent = Icons[iconName];

  if (!IconComponent) {
    return <Icons.IconQuestionMark size={size} color={color} className={className} />;
  }

  return <IconComponent size={size} color={color} className={className} />;
};

export default SportIcon;
